export const namespacer = (prefix, postfix) => `${prefix}/${postfix}`
